// extracted by mini-css-extract-plugin
export default {"modal":"knkmZ","modal--large":"np3qy","modal-background":"Wso_v knkmZ","overlay":"V1JIf","close-button":"bWhPw","dark-close-button":"CHtXZ","light-close-button":"WCmjo"};